import { Injectable } from '@angular/core';
import PipelineConfigurationModalsServiceBase from 'src/shared/services/pipeline-configuration-modals-service-base';

@Injectable({
    providedIn: 'root'
})
export default class PipelineConfigurationModalsService extends PipelineConfigurationModalsServiceBase {

    constructor() {
        super(true);
    }
}
